// import React, { useState, useEffect } from "react";
// import Table from "react-bootstrap/Table";
// import Modal from "react-bootstrap/Modal";
// import Button from "react-bootstrap/Button";
// import { useNavigate } from "react-router-dom";
// import "./ApplicationManagement.css";
// import NavigationBar from "../../Components/NavigationBar";

// export default function ShortlistApplicationURC() {
//   const [showModal, setShowModal] = useState(false);
//   const [applications, setApplications] = useState([]);
//   const [currentAppID, setCurrentAppID] = useState(null);
//   const navigate = useNavigate();
//   const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
//   const FILE_BASE_URL = process.env.REACT_APP_FILE_BASE_URL;

//   // Fetch applications from the backend
//   useEffect(() => {
//     fetch(`${API_BASE_URL}/getURCApplications`)
//       .then((response) => response.json())
//       .then((data) => {
//         console.log("Fetched Data:", data); // Log the API response
//         if (Array.isArray(data)) {
//           setApplications(data);
//         } else {
//           console.error("API did not return an array:", data);
//         }
//       })
//       .catch((error) => console.error("Error fetching applications:", error));
//   }, []);

//   // Handle the click event for the "Shortlisted" or "Rejected" button
//   const handleClick = (app_ID, status) => {
//     fetch(`${API_BASE_URL}/updateApplicationStatusURC`, {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json",
//       },
//       body: JSON.stringify({ applicationId: app_ID, status }),
//     })
//       .then((response) => response.json())
//       .then((data) => {
//         alert(`Application ID: ${app_ID} has been ${status}`);
//         setApplications((prevApplications) =>
//           prevApplications.map((app) =>
//             app.Application_Id === app_ID ? { ...app, Status: status } : app
//           )
//         );
//       })
//       .catch((error) =>
//         console.error("Error updating application status:", error)
//       );
//   };

//   // Open modal to choose shortlist/rejection
//   const handleOpenModal = (app_ID) => {
//     setCurrentAppID(app_ID);
//     setShowModal(true);
//   };

//   // Close the modal
//   const handleCloseModal = () => {
//     setShowModal(false);
//     setCurrentAppID(null);
//   };
//   const sendemailaccept = (app_ID) => {
//     fetch(`${API_BASE_URL}/sendEmailAccept`, {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json",
//       },
//       body: JSON.stringify({ applicationId: app_ID }),
//     })
//       .then((response) => response.json())
//       .then((data) => {
//         console.log("Email sent successfully:", data);
//       })
//       .catch((error) =>
//         console.error("Error sending email:", error)
//       );
//   };
//   const sendemailreject = (app_ID) => {
//     fetch(`${API_BASE_URL}/sendEmailReject`, {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json",
//       },
//       body: JSON.stringify({ applicationId: app_ID }),
//     })
//       .then((response) => response.json())
//       .then((data) => {
//         console.log("Email sent successfully:", data);
//       })
//       .catch((error) =>
//         console.error("Error sending email:", error)
//       );
//   };

//   return (
//     <div>
//       <NavigationBar />
//       <h1 className="page-name">Evaluate and Shortlist Applications - URC </h1>
//       <Table
//         striped
//         bordered
//         hover
//         style={{
//           marginTop: "20px",
//           boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)",
//         }}
//       >
//         <thead>
//           <tr>
//             <th>Application Id</th>
//             <th>Award Type</th>
//             <th>Submitted Date</th>
//             <th>Status</th>
//             <th>Action</th>
//             <th>Application</th>
//           </tr>
//         </thead>
//         <tbody>
//           {/* Display applications */}
//           {Array.isArray(applications) &&
//             applications.map((app) => (
//               <tr key={app.Application_Id}>
//                 <td>{app.Application_Id}</td>
//                 <td>{app.Award_Type}</td>
//                 <td>{app.SubmittedDate}</td>
//                 <td>{app.Status}</td>

//                 <td>
//                   {app.Status === "Approved" || app.Status === "Rejected" ? (
//                     <button
//                       className={
//                         app.Status === "Approved"
//                           ? "Shortlisted-button"
//                           : "Reject-button"
//                       }
//                       disabled
//                     >
//                       {app.Status}
//                     </button>
//                   ) : (
//                     <button
//                       className="select-unselect-button"
//                       onClick={() => handleOpenModal(app.Application_Id)}
//                     >
//                       Select
//                     </button>
//                   )}
//                 </td>

//                 <td>
//                   <button
//                     className="View_Button"
//                     onClick={() => {
//                       const formattedAwardType = app.Award_Type.replace(
//                         /\s+/g,
//                         "_"
//                       );
//                       const fileName = `${app.Application_Id}_${formattedAwardType}.pdf`;
//                       const fileUrl = `${FILE_BASE_URL}/ApplicationForms/${fileName}`;
//                       window.open(fileUrl, "_blank"); // Open in a new tab
//                     }}
//                   >
//                     View
//                   </button>
//                 </td>
//               </tr>
//             ))}
//         </tbody>
//       </Table>

//       {/* Modal for selecting shortlist or rejection */}
//       <Modal show={showModal} onHide={handleCloseModal}>
//         <Modal.Header closeButton>
//           <Modal.Title className="modaltitle">
//             Select Application Status
//           </Modal.Title>
//         </Modal.Header>

//         <Modal.Body>
//           <Button
//             variant="success"
//             className="granted_deny"
//             onClick={() => {
//               handleClick(currentAppID, "Shortlisted");
//               handleCloseModal();
//             }}
//           >
//             Approve
//           </Button>
//           <Button
//             variant="danger"
//             className="granted_deny"
//             onClick={() => {
//               handleClick(currentAppID, "Rejected");
//               handleCloseModal();
//             }}
//           >
//             Reject
//           </Button>
//         </Modal.Body>
//       </Modal>
//     </div>
//   );
// }
import React, { useState, useEffect } from "react";
import Table from "react-bootstrap/Table";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { useNavigate } from "react-router-dom";
import "./ApplicationManagement.css";
import NavigationBar from "../../Components/NavigationBar";

export default function ShortlistApplicationURC() {
  const [showModal, setShowModal] = useState(false);
  const [applications, setApplications] = useState([]);
  const [currentAppID, setCurrentAppID] = useState(null);
  const [awards, setAwards] = useState([]);
  const [selectedAward, setSelectedAward] = useState("");
  const [selectedYear, setSelectedYear] = useState("");
  const navigate = useNavigate();
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000/api';
  const FILE_BASE_URL = process.env.REACT_APP_FILE_BASE_URL || 'http://localhost:5000/uploads';

  const allowedAwardIds = [2, 3]; // URC Research Awards, Recognition Awards

  // Fetch applications and awards from the backend
  useEffect(() => {
    // Fetch applications
    fetch(`${API_BASE_URL}/getURCApplications`)
      .then((response) => response.json())
      .then((data) => {
        console.log("Fetched Applications:", data);
        if (Array.isArray(data)) {
          setApplications(data);
        } else {
          console.error("API did not return an array for applications:", data);
        }
      })
      .catch((error) => console.error("Error fetching applications:", error));

    // Fetch awards
    fetch(`${API_BASE_URL}/getAwards`)
      .then((response) => response.json())
      .then((data) => {
        console.log("Fetched Awards:", data);
        if (Array.isArray(data)) {
          const filteredAwards = data.filter((award) =>
            allowedAwardIds.includes(award.Award_Id)
          );
          setAwards(filteredAwards);
        } else {
          console.error("API did not return an array for awards:", data);
        }
      })
      .catch((error) => console.error("Error fetching awards:", error));
  }, [API_BASE_URL]);

  // Generate years from 2000 to current year
  const currentYear = new Date().getFullYear();
  const years = Array.from(
    { length: currentYear - 2024 + 1 },
    (_, i) => 2024 + i
  );

  // Filter applications based on selected award and year
  const filteredApplications = applications.filter((app) => {
    const matchesAward = selectedAward ? app.Award_Type === selectedAward : true;
    const matchesYear = selectedYear
      ? new Date(app.SubmittedDate).getFullYear().toString() === selectedYear
      : true;
    return matchesAward && matchesYear;
  });

  // Send acceptance email
  const sendemailaccept = async (app_ID, applicantName, applicantEmail, awardType) => {
    if (!applicantName || !applicantEmail || !awardType) {
      console.error("Missing required data for sending email:", { app_ID, applicantName, applicantEmail, awardType });
      return;
    }

    let emailSubject, emailBody;
    if (awardType === "URC Research Awards") {
      emailSubject = `URC Research Awards`;
      emailBody = `Dear ${applicantName},\n\nThank you for your application to the URC Research Award. I am delighted to inform you that your application (Application ID: ${app_ID}) has been successful. Congratulations on this well-deserved achievement!\n\nWe will provide further details regarding the date, time, and arrangements for the award ceremony in due course. Should you have any questions in the meantime, please feel free to contact us.\n\nOnce again, congratulations on your outstanding accomplishment.\n\nThis is a system-generated email, and please do not respond to this email.\n\nBest regards,\nDirector/URC`;
    } else if (awardType === "Recognition Awards") {
      emailSubject = `Recognition Awards for Research Grant Recipients`;
      emailBody = `Dear ${applicantName},\n\nThank you for your application to the Recognition Awards for research grant recipients. I am delighted to inform you that your application (Application ID: ${app_ID}) has been successful. Congratulations on this well-deserved achievement!\n\nWe will provide further details regarding the date, time, and arrangements for the award ceremony in due course. Should you have any questions in the meantime, please feel free to contact us.\n\nOnce again, congratulations on your outstanding accomplishment.\n\nThis is a system-generated email, and please do not respond to this email.\n\nBest regards,\nDirector/URC`;
    } else {
      console.error("Unknown award type:", awardType);
      return;
    }

    try {
      const emailResponse = await fetch(`${API_BASE_URL}/sendEmail`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          to: applicantEmail,
          subject: emailSubject,
          text: emailBody,
          html: `<p>${emailBody.replace(/\n/g, '<br>')}</p>`,
        }),
      });
      const emailData = await emailResponse.json();
      if (!emailResponse.ok) throw new Error(emailData.message || "Failed to send email");

      const logResponse = await fetch(`${API_BASE_URL}/saveApplicantEmailDetails`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          App_Id: app_ID,
          Applicant_Name: applicantName,
          Applicant_Email: applicantEmail,
          Sent: 1,
        }),
      });
      const logData = await logResponse.json();
      if (!logResponse.ok) throw new Error(logData.message || "Failed to log email");

      console.log("Email sent and logged successfully:", emailData, logData);
    } catch (error) {
      console.error("Error sending or logging email:", error);
    }
  };

  // Send rejection email
  const sendemailreject = async (app_ID, applicantName, applicantEmail, awardType) => {
    if (!applicantName || !applicantEmail || !awardType) {
      console.error("Missing required data for sending email:", { app_ID, applicantName, applicantEmail, awardType });
      return;
    }

    let emailSubject, emailBody;
    if (awardType === "URC Research Awards") {
      emailSubject = `URC Research Award`;
      emailBody = `Dear ${applicantName},\n\nThank you for submitting your application for the URC Research Award (Application ID: ${app_ID}). We greatly appreciate the time and effort you invested in the application process. I regret to inform you that your application was not successful.\n\nShould you have any questions or wish to receive feedback on your application, please feel free to contact us at secretaryurc@gs.pdn.ac.lk.\n\nThank you again for your interest in the URC Research Award.\n\nThis is a system-generated email, and please do not respond to this email.\n\nBest regards,\nDirector/URC`;
    } else if (awardType === "Recognition Awards") {
      emailSubject = `Recognition Awards for Research Grant Recipients`;
      emailBody = `Dear ${applicantName},\n\nThank you for submitting your application for the Recognition Awards for research grant recipients (Application ID: ${app_ID}). We greatly appreciate the time and effort you invested in the application process. I regret to inform you that your application was not successful.\n\nShould you have any questions or wish to receive feedback on your application, please feel free to contact us at secretaryurc@gs.pdn.ac.lk.\n\nThank you again for your interest in the Recognition Awards for research grant recipients.\n\nThis is a system-generated email, and please do not respond to this email.\n\nBest regards,\nDirector/URC`;
    } else {
      console.error("Unknown award type:", awardType);
      return;
    }

    try {
      const emailResponse = await fetch(`${API_BASE_URL}/sendEmail`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          to: applicantEmail,
          subject: emailSubject,
          text: emailBody,
          html: `<p>${emailBody.replace(/\n/g, '<br>')}</p>`,
        }),
      });
      const emailData = await emailResponse.json();
      if (!emailResponse.ok) throw new Error(emailData.message || "Failed to send email");

      const logResponse = await fetch(`${API_BASE_URL}/saveApplicantEmailDetails`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          App_Id: app_ID,
          Applicant_Name: applicantName,
          Applicant_Email: applicantEmail,
          Sent: 1,
        }),
      });
      const logData = await logResponse.json();
      if (!logResponse.ok) throw new Error(logData.message || "Failed to log email");

      console.log("Email sent and logged successfully:", emailData, logData);
    } catch (error) {
      console.error("Error sending or logging email:", error);
    }
  };

  // Handle the click event for the "Approved" or "Rejected" button
  const handleClick = (app_ID, status) => {
    const application = applications.find(app => app.Application_Id === app_ID);
    if (!application) {
      alert("Application not found.");
      return;
    }

    fetch(`${API_BASE_URL}/updateApplicationStatusURC`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ applicationId: app_ID, status }),
    })
      .then((response) => response.json())
      .then((data) => {
        alert(`Application ID: ${app_ID} has been ${status}`);
        setApplications((prevApplications) =>
          prevApplications.map((app) =>
            app.Application_Id === app_ID ? { ...app, Status: status } : app
          )
        );

        if (status === "Approved") {
          sendemailaccept(app_ID, application.Applicant_Name, application.Email, application.Award_Type);
        } else if (status === "Rejected") {
          sendemailreject(app_ID, application.Applicant_Name, application.Email, application.Award_Type);
        }
      })
      .catch((error) => {
        console.error("Error updating application status:", error);
        alert("Error updating application status.");
      });
  };

  // Open modal to choose approve/reject
  const handleOpenModal = (app_ID) => {
    setCurrentAppID(app_ID);
    setShowModal(true);
  };

  // Close the modal
  const handleCloseModal = () => {
    setShowModal(false);
    setCurrentAppID(null);
  };

  return (
    <div>
      <NavigationBar />
      <h1 className="page-name">Evaluate and Shortlist Applications - URC</h1>
      <div style={{ margin: "20px 0", display: "flex", gap: "20px" }}>
        <div>
          <label htmlFor="awardFilter">Filter by Award: </label>
          <select
            id="awardFilter"
            value={selectedAward}
            onChange={(e) => setSelectedAward(e.target.value)}
            style={{
              padding: "5px",
              marginLeft: "10px",
              minWidth: "200px",
              color: "#000",
              backgroundColor: "#fff",
              border: "1px solid #ccc",
            }}
          >
            <option value="">All Awards</option>
            {awards.length > 0 ? (
              awards.map((award) => (
                <option key={award.Award_Id} value={award.Name}>
                  {award.Name || "Unnamed Award"}
                </option>
              ))
            ) : (
              <option disabled>No awards available</option>
            )}
          </select>
        </div>
        <div>
          <label htmlFor="yearFilter">Filter by Year: </label>
          <select
            id="yearFilter"
            value={selectedYear}
            onChange={(e) => setSelectedYear(e.target.value)}
            style={{
              padding: "5px",
              marginLeft: "10px",
              minWidth: "100px",
              color: "#000",
              backgroundColor: "#fff",
              border: "1px solid #ccc",
            }}
          >
            <option value="">All Years</option>
            {years.map((year) => (
              <option key={year} value={year}>
                {year}
              </option>
            ))}
          </select>
        </div>
      </div>
      <Table
        striped
        bordered
        hover
        style={{
          marginTop: "20px",
          boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)",
        }}
      >
        <thead>
          <tr>
            <th>Applicant Name</th>
            <th>Application Id</th>
            <th>Award Type</th>
            <th>Submitted Date</th>
            <th>Status</th>
            <th>Action</th>
            <th>Application</th>
          </tr>
        </thead>
        <tbody>
          {Array.isArray(filteredApplications) &&
            filteredApplications.map((app) => (
              <tr key={app.Application_Id}>
                <td>{app.Applicant_Name}</td>
                <td>{app.Application_Id}</td>
                <td>{app.Award_Type}</td>
                <td>{app.SubmittedDate}</td>
                <td>{app.Status}</td>
                <td>
                  {app.Status === "Approved" || app.Status === "Rejected" ? (
                    <button
                      className={
                        app.Status === "Approved"
                          ? "Shortlisted-button"
                          : "Reject-button"
                      }
                      disabled
                    >
                      {app.Status}
                    </button>
                  ) : (
                    <button
                      className="select-unselect-button"
                      onClick={() => handleOpenModal(app.Application_Id)}
                    >
                      Select
                    </button>
                  )}
                </td>
                <td>
                  <button
                    className="View_Button"
                    onClick={() => {
                      const formattedAwardType = app.Award_Type.replace(
                        /\s+/g,
                        "_"
                      );
                      const fileName = `${app.Application_Id}_${formattedAwardType}.pdf`;
                      const fileUrl = `${FILE_BASE_URL}/api/Uploads/ApplicationForms/${fileName}`;
                      window.open(fileUrl, "_blank");
                    }}
                  >
                    View
                  </button>
                </td>
              </tr>
            ))}
        </tbody>
      </Table>

      <Modal show={showModal} onHide={handleCloseModal}>
        <Modal.Header closeButton>
          <Modal.Title className="modaltitle">
            Select Application Status
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Button
            variant="success"
            className="granted_deny"
            onClick={() => {
              handleClick(currentAppID, "Approved");
              handleCloseModal();
            }}
          >
            Approve
          </Button>
          <Button
            variant="danger"
            className="granted_deny"
            onClick={() => {
              handleClick(currentAppID, "Rejected");
              handleCloseModal();
            }}
          >
            Reject
          </Button>
        </Modal.Body>
      </Modal>
    </div>
  );
}